export default "__VITE_ASSET__Cvm2m5W8__"